export default "__VITE_ASSET__DOPi$U_0__"